// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const StatusListingRoot = styled.div`
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 2;
`;
